console.log(`Client : All is Ok`);

import { io } from 'socket.io-client';

let socket = io("https://mangetout-back-58d6f9597b75.herokuapp.com/", {
    transports: ["websocket", "polling"], // Ajoute polling en fallback
    withCredentials: true
});

const body = document.querySelector('body');
const home = document.querySelector('.home');
const playView = document.querySelector('.play');
const waitView = document.querySelector('.wait');
const leaderboardView = document.querySelector('.leaderboard-page');
const replayView = document.querySelector('.replay');

const startForm = document.querySelector(".start-form");
const creditView = document.querySelector(".credit");

const scoreTitle = document.querySelector(".score h3");

const playerCount = document.querySelector(".player-count");

const leaderboardBtn = document.querySelector(".btn-leaderboard");
const homeBtn = document.querySelector(".btn-home");

const tutorielBtn = document.querySelector(".btn-tutoriel");
const tutorielView = document.querySelector(".tutoriel");
const homeBtnTuto = document.querySelector(".btn-home-tuto");
const creditBtn = document.querySelector(".btn-credit");
const homeBtnCredit = document.querySelector(".btn-home-credit");

let gameTimer;
let temps = 0;
function timer() {
    temps++;
}

let playersList = [];
let foodList = [];

let gameIsStarted = false;

let yourScore = 0;

let mapSizeX = 0;
let mapSizeY = 0;
const squirtleImg = new Image();
const charmanderImg = new Image();
const bulbasaurImg = new Image();

let interval;

const imageBaieCeriv = new Image();
imageBaieCeriv.src = 'images/baie/Baie_Ceriv.png';
const imageBaieFraive = new Image();
imageBaieFraive.src = 'images/baie/Baie_Fraive.png';
const imageBaieMarron = new Image();
imageBaieMarron.src = 'images/baie/Baie_Marron.png';
const imageBaieMepo = new Image();
imageBaieMepo.src = 'images/baie/Baie_Mepo.png';
const imageBaieWillia = new Image();
imageBaieWillia.src = 'images/baie/Baie_Willia.png';



function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
}

// Ajuster la taille au chargement

let name;
let selectedSkin;

// Valider le pseudo
startForm.addEventListener("submit", (e) => {
    e.preventDefault();

    home.classList.add("disabled");
    // waiting screen
    waitView.classList.remove("disabled");

    // notifier l'ajout du joueur au server
    name = e.target.querySelector("input[type='text']").value;
    selectedSkin = e.target.querySelector("input[name='skin']:checked").value;
    socket.emit('add-player', name, selectedSkin);


})

//Aller sur la page des crédits

creditBtn.addEventListener('click', (e) => {
    e.preventDefault();
    home.classList.add("disabled");
    creditView.classList.remove("disabled");
})

homeBtnCredit.addEventListener('click', (e) => {
    e.preventDefault();
    creditView.classList.add("disabled");
    home.classList.remove("disabled");
})


// Modification du nombre de joueur en attente.
socket.on("wait", (users, needed) => {
    playerCount.innerHTML = `${users}/${needed} joueurs en attente`;
})


const canvas = document.getElementById('gameCanvas');
const context = canvas.getContext('2d');




let x = 0;
let y = 0;
let vx = 0;
let vy = 0;
let speed = 2;
const width = 50;
const height = 50;
let xDirection = 0;
let yDirection = 0;

let targetX = x;
let targetY = y;

let imagesLoaded = 0;



function connectSocketToServer() {
    socket.on('start-game', onStartGame);
    socket.on('global-leaderboard-update', globalLeaderboardUpdate);
    temps=0;
    gameTimer = setInterval(timer, 1000);
}

let animationFrame;

connectSocketToServer();
// Début de la partie
function onStartGame(messages, players, food, x, y) {
    if(gameIsStarted) return;
    socket.connect();
    resizeCanvas();
// ajouste la taille au resize de la fenetre
    window.addEventListener("resize", resizeCanvas);
    gameIsStarted = true;
    playersList = players;
    foodList = food;

    mapSizeX = x;
    mapSizeY = y;



    let currentPlayer;
    playersList.forEach(joueur => {
        if (joueur.id === socket.id) {
            currentPlayer = joueur;
        }
    })

    if(currentPlayer === undefined) return;
    gameTimer = setInterval(timer, 1000);
    x = currentPlayer.posX;
    y = currentPlayer.posY;

    // === Lancement du canvas ici ===
    let gameMode = true ;

    gameMode = (!document.querySelector('#mouse').checked);


    if(!gameMode) {
        canvas.addEventListener('mousemove', (e) => {
            const rect = canvas.getBoundingClientRect();
            targetX = e.clientX - rect.left;
            targetY = e.clientY - rect.top;
        });
    }





    squirtleImg.src = '/images/Squirtle.png';
    charmanderImg.src = '/images/Charmander.png';
    bulbasaurImg.src = '/images/Bulbasaur.png';



    let imagesToLoad = 3;

    function checkAllImagesLoaded() {
        imagesToLoad--;
        if (imagesToLoad === 0) {
            animationFrame = requestAnimationFrame(render);
            interval = setInterval(moveMonster, 1000 / 60);
        }
    }

    squirtleImg.onload = checkAllImagesLoaded;
    charmanderImg.onload = checkAllImagesLoaded;
    bulbasaurImg.onload = checkAllImagesLoaded;


    //desactive l'ecran d'accueil
    waitView.classList.add("disabled");
    playView.classList.remove("disabled");

    function moveMonster() {


        //calcul de la speed
        speed = Math.max(1.0, 5.0 / (1 + (yourScore / 500.0)));


        if(gameMode){
            if(xDirection === 1) {
                x+= speed;
            }else if(xDirection === -1) {
                x-= speed;
            }
            if(yDirection === 1){
                y+= speed;
            }else if(yDirection === -1) {
                y-= speed;
            }
        }else {

            // relation coord server/client

            let dx = targetX - canvas.width/2;
            let dy = targetY - canvas.height/2;




            let serverTargetX, serverTargetY;

            serverTargetX = x +dx;
            serverTargetY = y +dy;


            let sdx = serverTargetX - x;
            let sdy = serverTargetY - y;
            let sdistance = Math.sqrt(sdx * sdx + sdy * sdy);


            if (sdistance > 1) {
                const maxSpeed = 5; // Limite de vitesse
                const factor = 0.05; // Plus petit = accélère moins vite
                let dynamicSpeed = Math.min(sdistance * factor, maxSpeed);
                dynamicSpeed = Math.max(1.0, dynamicSpeed / (1 + (yourScore / 500.0)));
                x -= (sdx / sdistance) * dynamicSpeed;
                y -= (sdy / sdistance) * dynamicSpeed;
            }

            // Normalisation pour obtenir une direction constante


        }






        socket.emit('move', x, y);

        // Empêcher de sortir du canvas
    }



    // GESTION DES CONTROLES

    document.addEventListener('keydown', (event) => {
        switch (event.key) {
            case 'ArrowRight':
                xDirection = -1;
                break;
            case 'ArrowLeft':
                xDirection = 1;
                break;
            case 'ArrowUp':
                yDirection = 1;
                break;
            case 'ArrowDown':
                yDirection = -1;
                break;
        }
    });

    document.addEventListener('keyup', (event) => {
        switch (event.key) {
            case 'ArrowRight':
            case 'ArrowLeft':
                xDirection = 0;
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                yDirection = 0;
                break;
        }
    });

    socket.on('player-move', onPlayerMove)

    socket.on('end-game', endGame)


    socket.on('leaderboard-update', updateLeaderboard);

}





// RENDER

function render() {
    if(!gameIsStarted) return;
    let currentPlayer;
    context.clearRect(0, 0, canvas.width, canvas.height);
    playersList.forEach(joueur => {
        if (joueur.id === socket.id) {
            currentPlayer = joueur;
        }
    })


    if(currentPlayer === undefined)return;


    if(currentPlayer.posX <= canvas.width/2){
        context.beginPath();
        context.moveTo(canvas.width/2 + currentPlayer.posX,0);
        context.lineTo(canvas.width/2 + currentPlayer.posX, canvas.height);
        context.stroke();
    }

    // Bordure droite
    if (mapSizeX - currentPlayer.posX <= canvas.width / 2) {
        context.beginPath();
        context.moveTo(canvas.width / 2 - (mapSizeX - currentPlayer.posX), 0);
        context.lineTo(canvas.width / 2 - (mapSizeX - currentPlayer.posX), canvas.height);
        context.stroke();
    }

// Bordure haute
    if (currentPlayer.posY <= canvas.height / 2) {
        context.beginPath();
        context.moveTo(0, canvas.height / 2 + currentPlayer.posY);
        context.lineTo(canvas.width, canvas.height / 2 + currentPlayer.posY);
        context.stroke();
    }

// Bordure basse
    if (mapSizeY - currentPlayer.posY <= canvas.height / 2) {
        context.beginPath();
        context.moveTo(0, canvas.height / 2 - (mapSizeY - currentPlayer.posY));
        context.lineTo(canvas.width, canvas.height / 2 - (mapSizeY - currentPlayer.posY));
        context.stroke();
    }


    foodList.forEach(food => {
        if(currentPlayer.posX - food.x <= canvas.width/2 && currentPlayer.posY - food.y <= canvas.height/2 ) {
            context.beginPath();
            if (food.type === 0) {
                context.drawImage(imageBaieCeriv, canvas.width/2 + (currentPlayer.posX - food.x) - 10, canvas.height/2 + (currentPlayer.posY - food.y) -10, 20, 20);
            } else if (food.type === 1) {
                context.drawImage(imageBaieFraive, canvas.width/2 + (currentPlayer.posX - food.x) - 10, canvas.height/2 + (currentPlayer.posY - food.y)- 10, 20, 20);
            } else if (food.type === 2) {
                context.drawImage(imageBaieMarron, canvas.width/2 + (currentPlayer.posX - food.x)- 10, canvas.height/2 + (currentPlayer.posY - food.y)- 10, 20, 20);
            } else if (food.type === 3) {
                context.drawImage(imageBaieMepo, canvas.width/2 + (currentPlayer.posX - food.x)- 10, canvas.height/2 + (currentPlayer.posY - food.y)- 10, 20, 20);
            } else if (food.type === 4){
                context.drawImage(imageBaieWillia, canvas.width/2 + (currentPlayer.posX - food.x)- 10, canvas.height/2 + (currentPlayer.posY - food.y)- 10, 20, 20);
            }
            context.stroke();
        }

    })

    playersList.forEach(joueur => {
        if(joueur.id !== currentPlayer.id){
            if(currentPlayer.posX - joueur.posX <= canvas.width/2 && currentPlayer.posY - joueur.posY <= canvas.height/2 ) {
                context.beginPath();

                const drawX = canvas.width / 2 + (currentPlayer.posX - joueur.posX) - joueur.size/2;
                const drawY = canvas.height / 2 + (currentPlayer.posY - joueur.posY) - joueur.size/2;

                switch (joueur.skin) {
                    case "Charmander":
                        context.drawImage(charmanderImg, drawX-joueur.size/2, drawY-joueur.size/2, joueur.size*2, joueur.size*2);
                        break;
                    case "Bulbasaur":
                        context.drawImage(bulbasaurImg, drawX-joueur.size/2, drawY-joueur.size/2, joueur.size*2, joueur.size*2);
                        break;
                    case "Squirtle":
                        context.drawImage(squirtleImg, drawX-joueur.size/2, drawY-joueur.size/2, joueur.size*2, joueur.size*2);
                        break;
                }
                //context.arc(canvas.width/2 + (currentPlayer.posX - joueur.posX) , canvas.height/2 + (currentPlayer.posY - joueur.posY), joueur.size, 0, Math.PI * 2);
              //  context.fill();
            }
        }

    })

    // Dessiner le joueur courant
    context.beginPath();
    //context.arc(canvas.width/2, canvas.height/2, currentPlayer.size , 0, Math.PI * 2);
    switch (currentPlayer.skin) {
        case "Charmander":
            context.drawImage(charmanderImg, canvas.width / 2 - currentPlayer.size, canvas.height / 2 - currentPlayer.size, currentPlayer.size*2, currentPlayer.size*2);
            break;
        case "Bulbasaur":
            context.drawImage(bulbasaurImg, canvas.width / 2 - currentPlayer.size, canvas.height / 2 - currentPlayer.size, currentPlayer.size*2, currentPlayer.size*2);
            break;
        case "Squirtle":
            context.drawImage(squirtleImg, canvas.width / 2 - currentPlayer.size, canvas.height / 2 - currentPlayer.size, currentPlayer.size*2, currentPlayer.size*2);
            break;
    }
    context.beginPath();
    context.arc(canvas.width / 2, canvas.height / 2 , currentPlayer.size, 0, Math.PI * 2);
    context.strokeStyle = "gray"; // Couleur de la hitbox
    context.lineWidth = 4;
    context.stroke();

  //  context.fill();
    /**
     players.forEach((player) => {
     context.arc(player.positionX, player.positionY, 30, 0, Math.PI * 2);
     context.fillStyle = "blue";
     context.stroke();
     context.fill();
     })
     */
    animationFrame = requestAnimationFrame(render);
}




// Mouvement d'un joueur

function onPlayerMove(players, food) {
    playersList = players;
    foodList = food;
}



function endGame(win) {
    replayView.classList.remove("disabled");
   // cancelAnimationFrame(animationFrame);
    gameIsStarted = false;
    clearInterval(interval);
    clearInterval(gameTimer)
    console.log("Finish game");
    socket.emit("end-game");
    socket = io(window.location.hostname + ':9090');

    if(win) {
        replayView.querySelector("h1").innerHTML = "Bravo, vous avez gagnez !"
    }

    replayView.querySelector("#score").innerHTML = `Votre score : ${yourScore}`;
    const minute = Math.floor(temps/60);
    replayView.querySelector("#temps").innerHTML = `Votre temps : ${minute}:${temps-(60*minute)}`;

    connectSocketToServer();
    yourScore = 0;

    replayView.querySelector(".btn-rejouer").addEventListener('click', () => {
        socket.emit('add-player', name, selectedSkin);
        replayView.classList.add("disabled");
    })
}






const leaderboardList = document.querySelector('.leaderboard-list');

function updateLeaderboard(players) {
    // Trier les joueurs par taille décroissante
    const sortedPlayers = [...players].sort((a, b) => b.score - a.score);

    // Générer le HTML du classement
    leaderboardList.innerHTML = '';
    sortedPlayers.forEach((player, index) => {

        const isYou = player.id === socket.id;
        let li;
        if(index < 5) {
           li = document.createElement('li');
            li.textContent = `${index + 1}. ${player.name || 'Anonyme'} (${Math.round(player.score)})`;
        }

        // Ajoute la class you pour savoir ou tu est
        if (isYou) {
            if(index < 5) {
                li.classList.add('you');
            }
            yourScore = player.score
            scoreTitle.innerHTML = ` ${player.score}`;
        }
        if(index < 5) {
            leaderboardList.appendChild(li);
        }
    });
}

// Bouton leaderboard --> home et home --> leaderboard
leaderboardBtn.addEventListener('click', (e) => {
    e.preventDefault();
    socket.emit("ask-leaderboard")
    home.classList.add("disabled");
    leaderboardView.classList.remove("disabled");
})
homeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    leaderboardView.classList.add("disabled");
    home.classList.remove("disabled");
})



// Tutoriel affichage

tutorielBtn.addEventListener('click', (e) => {
    e.preventDefault();
    home.classList.add("disabled");
    tutorielView.classList.remove("disabled");
})

homeBtnTuto.addEventListener('click', (e) => {
    e.preventDefault();
    tutorielView.classList.add("disabled");
    home.classList.remove("disabled");
})



// recuperation des données du leaderboard:
function globalLeaderboardUpdate(leaderboard)  {
    const ol = document.querySelector('.leaderboard-page-div ol');
    if(leaderboard === undefined || leaderboard.length === 0) {
        ol.innerHTML = "<li> Aucune données trouvées</li>";
    } else {
        ol.innerHTML = `<li><span class="crown">👑</span> 1. ${leaderboard[0].username} - ${leaderboard[0].score} pts <span class="date">(${new Date(leaderboard[0].score_date).toLocaleDateString("fr-FR")})</span></li>`
        for(let i =1; i < leaderboard.length; i++) {
            ol.innerHTML+=  `<li> ${i}. ${leaderboard[i].username} - ${leaderboard[i].score} pts <span class="date">(${new Date(leaderboard[i].score_date).toLocaleDateString("fr-FR")})</span></li>`
        }
    }
}

